import Icon, { ICON_MAP } from '@mindtickle/icon';
import Label from '@mindtickle/label';
import { TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';
import { Suspense } from 'react';
import { compose } from 'recompose';
import { withRedux } from '~/components/Redux';
import { withRelay } from '~/components/Relay';
import { withSnowPlow as withSnowplow } from '~/components/Snowplow';
import { APP_NAME, DYNAMIC_REMOTES } from '~/config/app.constants';
import globalEnv from '~/config/env';
import { useImpersonation } from '~/hooks/useImpersonation';
import { useUserAuth } from '../Auth';
import useTracker from '../GlobalHeader/Learner/hooks/useTracker';
import messages from './messages';
import { StyledImpersonationBanner } from './styles';
import { InlineSkeleton } from '@mindtickle/skeleton';
import { IMPERSONATION_LOADER } from './constants';
import EllipsisTooltip from '@mindtickle/ellipsis-tooltip';

const ImpersonationBanner = () => {
  const isImpersonated = useImpersonation();
  const { name, userName } = useUserAuth();
  const track = useTracker();

  if (!isImpersonated) {
    return null;
  }

  return (
    <StyledImpersonationBanner>
      <section className="left-impersonation-section">
        <Icon type={ICON_MAP.LEARNERS_FILLED} className="impersonated-user-icon" />
        <Label
          className="impersonating-text"
          message={messages.IMPERSONATING}
          type={TEXT_TYPES.BODY_MEDIUM_DEFAULT}
        />
        <Label className="impersonating-username" type={TEXT_TYPES.HEADING_XSMALL}>
          <EllipsisTooltip title={name || userName}>{name || userName}</EllipsisTooltip>
        </Label>
      </section>
      <section className="right-impersonation-section">
        <Suspense fallback={<InlineSkeleton style={IMPERSONATION_LOADER} />}>
          <LoadRemote
            lazy={false}
            remote={DYNAMIC_REMOTES.IMPERSONATION}
            loader={<InlineSkeleton style={IMPERSONATION_LOADER} />}
            track={track}
          />
        </Suspense>
      </section>
    </StyledImpersonationBanner>
  );
};

export default compose(
  withSnowplow({
    collectorUrl: globalEnv.RXP_SVC_SNOWPLOW_INGRESS,
    namespace: APP_NAME,
  }),
  withRedux(),
  withRelay({
    enableSubscription: false,
    graphqlEndpoint: globalEnv.READINESS_GQL_API_ENDPOINT,
  })
)(ImpersonationBanner);
